import { render, staticRenderFns } from "./profile-view.vue?vue&type=template&id=71950a46&"
import script from "./profile-view.vue?vue&type=script&lang=js&"
export * from "./profile-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports